var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('account-form',{staticClass:"max-w-sm mx-auto pb-10",attrs:{"enable-incomplete-registration":true}}),_c('div',{staticClass:"clear--sm"}),_c('supported-cards'),_c('div',{staticClass:"clear--sm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }